/* Modified for Meadows Farms: Search & Discovery filters now update the product grid
   without a full page reload (previously the filter form was submitted on every change). */
(() => {
Shopify.theme.jsSidebar = {
  init: function() {
    const self = this;
    const form = document.querySelector('[data-faceted-filter-form]');

    if (form && form.dataset.ajaxFilterBound !== 'true') {
      form.dataset.ajaxFilterBound = 'true';

      // Checkbox changes filter instantly (price inputs wait for the Apply button)
      form.addEventListener('change', function(e) {
        if (e.target.type === 'number') return;
        self.filterFromForm(form);
      });

      // Apply buttons (price range) filter without reloading
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        self.filterFromForm(form);
      });

      // "Clear", "Clear all" and active-filter remove links
      form.addEventListener('click', function(e) {
        const link = e.target.closest('a.faceted-active-filters__remove-filter, a.faceted-filter-group-display__header-clear, a.faceted-active-filters__clear, .faceted-active-filters__clear a');
        if (!link || !link.getAttribute('href')) return;
        e.preventDefault();
        self.loadFilteredPage(link.href, true);
      });
    }

    if (!self.globalListenersBound) {
      self.globalListenersBound = true;

      // Back/forward buttons restore the matching filtered view
      window.addEventListener('popstate', function() {
        if (document.querySelector('[data-faceted-filter-form]')) {
          self.loadFilteredPage(window.location.href, false);
        }
      });

      // Keep active filters when the "Sort by" dropdown changes
      document.addEventListener('change', function(e) {
        if (!e.target || e.target.id !== 'sort-by') return;
        if (!document.querySelector('[data-faceted-filter-form]')) return;
        e.stopPropagation();
        const params = new URLSearchParams(window.location.search);
        params.delete('page');
        if (e.target.value) { params.set('sort_by', e.target.value); } else { params.delete('sort_by'); }
        const qs = params.toString();
        self.loadFilteredPage(window.location.pathname + (qs ? '?' + qs : ''), true);
      }, true);
    }

    const openSidebarBlocks = document.querySelectorAll('[data-sidebar-block__toggle="open"]');
    openSidebarBlocks.forEach(function(block) {
      self.openSidebarBlock($(block));
    });

    // Delegated so toggles keep working after the sidebar is refreshed
    $(document).off('click.jsSidebarToggle').on('click.jsSidebarToggle', '[data-has-toggle-option] [data-sidebar-block__toggle]', function(e) {
      e.preventDefault();
      if ($(this).attr('data-sidebar-block__toggle') === 'open') {
        self.closeSidebarBlock($(this));
      } else {
        self.openSidebarBlock($(this));
      }
    });

    self.setupMobileToggle();

    if ($('[data-product-sidebar]').length) {
      $('.section--has-sidebar-option').addClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').removeClass('has-sidebar-disabled');
    } else {
      $('.section--has-sidebar-option').removeClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').addClass('has-sidebar-disabled');
    }
  },

  filterFromForm: function(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach(function(value, key) {
      if (value !== '') params.append(key, value);
    });
    const sort = new URLSearchParams(window.location.search).get('sort_by');
    if (sort) params.set('sort_by', sort);
    const qs = params.toString();
    this.loadFilteredPage(window.location.pathname + (qs ? '?' + qs : ''), true);
  },

  loadFilteredPage: function(url, push) {
    const self = this;
    const main = document.querySelector('[data-collection-main]');
    const form = document.querySelector('[data-faceted-filter-form]');
    if (!main || !form || !window.fetch || !window.DOMParser) {
      window.location.href = url;
      return;
    }

    if (self.currentRequest) self.currentRequest.abort();
    const controller = ('AbortController' in window) ? new AbortController() : null;
    self.currentRequest = controller;

    $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
    $('.collection-matrix__wrapper .collection__loading-icon').fadeIn();

    const openLabels = self.getOpenLabels(form);

    fetch(url, { credentials: 'same-origin', signal: controller ? controller.signal : undefined })
      .then(function(response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newForm = doc.querySelector('[data-faceted-filter-form]');
        const newMain = doc.querySelector('[data-collection-main]');
        if (!newForm || !newMain) throw new Error('Filtered content not found');

        form.innerHTML = newForm.innerHTML;
        main.innerHTML = newMain.innerHTML;

        ['.product-count', '.breadcrumb__container'].forEach(function(selector) {
          const current = document.querySelector(selector);
          const updated = doc.querySelector(selector);
          if (current && updated) current.innerHTML = updated.innerHTML;
        });

        if (push && window.history && window.history.pushState) {
          window.history.pushState({ facetedFilter: true }, '', url);
        }

        self.restoreOpenBlocks(form, openLabels);
        self.updateToggleLabel();

        try {
          if (Shopify.theme_settings && Shopify.theme_settings.enable_shopify_collection_badges == true && Shopify.theme.productReviews) {
            Shopify.theme.productReviews();
          }
        } catch (err) {}
        try {
          if ($('[data-custom-pagination]').length && Shopify.theme.infiniteScroll) {
            Shopify.theme.infiniteScroll.update();
          }
        } catch (err) {}
      })
      .catch(function(err) {
        if (err && err.name === 'AbortError') return;
        // Fall back to a normal page load if anything goes wrong
        window.location.href = url;
      });
  },

  // Mobile: filters sit behind a "Show filters" button instead of above all products
  setupMobileToggle: function() {
    const self = this;
    const aside = document.querySelector('.sidebar-section');
    const form = document.querySelector('[data-faceted-filter-form]');
    if (!aside || !form) return;

    aside.classList.add('has-mf-toggle');

    if (!document.querySelector('[data-mf-filter-toggle]')) {
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'button button--primary mf-filter-toggle';
      toggle.setAttribute('data-mf-filter-toggle', '');
      toggle.setAttribute('aria-expanded', 'false');
      aside.parentNode.insertBefore(toggle, aside);
      toggle.addEventListener('click', function() {
        const open = !aside.classList.contains('mf-filters-open');
        aside.classList.toggle('mf-filters-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        self.updateToggleLabel();
        self.positionToggle();
      });

      // Keep the sticky "Hide filters" button just below the site header while scrolling
      let ticking = false;
      window.addEventListener('scroll', function() {
        if (ticking || toggle.getAttribute('aria-expanded') !== 'true') return;
        ticking = true;
        window.requestAnimationFrame(function() {
          self.positionToggle();
          ticking = false;
        });
      }, { passive: true });
      window.addEventListener('resize', function() { self.positionToggle(); });
    }

    self.updateToggleLabel();
  },

  positionToggle: function() {
    const toggle = document.querySelector('[data-mf-filter-toggle]');
    if (!toggle) return;
    let top = 10;
    document.querySelectorAll('.top-bar, .mobile-header, .mobile-logo, #mobile-header-sticky-wrapper').forEach(function(el) {
      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      const rect = el.getBoundingClientRect();
      // Only count header pieces that are currently pinned at the top of the screen
      if (rect.height > 0 && rect.top <= 1 + top && rect.bottom > top && rect.bottom < window.innerHeight / 2) {
        top = rect.bottom;
      }
    });
    toggle.style.setProperty('--mf-toggle-top', Math.round(top + 8) + 'px');
  },

  updateToggleLabel: function() {
    const toggle = document.querySelector('[data-mf-filter-toggle]');
    const aside = document.querySelector('.sidebar-section');
    const form = document.querySelector('[data-faceted-filter-form]');
    if (!toggle || !aside || !form) return;
    const count = form.querySelectorAll('input[type="checkbox"]:checked').length;
    const open = aside.classList.contains('mf-filters-open');
    toggle.textContent = open ? 'Hide Filters' : 'Show Filters' + (count ? ' (' + count + ')' : '');
  },

  normalizeLabel: function(el) {
    return (el.textContent || '').replace(/\(\d+\)/g, '').replace(/\s+/g, ' ').trim();
  },

  getOpenLabels: function(form) {
    const self = this;
    return Array.prototype.map.call(form.querySelectorAll('[data-sidebar-block__toggle="open"]'), function(el) {
      return self.normalizeLabel(el);
    });
  },

  restoreOpenBlocks: function(form, labels) {
    const self = this;
    form.querySelectorAll('[data-sidebar-block__toggle]').forEach(function(el) {
      if (el.getAttribute('data-sidebar-block__toggle') === 'open' || labels.indexOf(self.normalizeLabel(el)) > -1) {
        self.openSidebarBlock($(el), true);
      }
    });
  },

  openSidebarBlock: function($toggleBtn, instant) {
    const $parentBlock = $toggleBtn.closest('.sidebar__block');
    const $content = $parentBlock.find('[data-sidebar-block__content--collapsible]');

    $toggleBtn.attr('data-sidebar-block__toggle', 'open');
    $parentBlock.addClass('is-active');
    $parentBlock.attr('aria-expanded', true);
    if (instant) { $content.show(); } else { $content.slideDown(); }
  },

  closeSidebarBlock: function($toggleBtn) {
    const $parentBlock = $toggleBtn.closest('.sidebar__block');

    $toggleBtn.attr('data-sidebar-block__toggle', 'closed');
    $parentBlock.removeClass('is-active');
    $parentBlock.attr('aria-expanded', false);
    $parentBlock.find('[data-sidebar-block__content--collapsible]').slideUp();
  },

  unload: function() {
    $(document).off('click.jsSidebarToggle');
  }
}
})();
